import { Reveal, SectionHead } from "./Reveal";
import { INDUSTRIES } from "@/data/content";
import { Building2 } from "lucide-react";

const Industries = () => (
    <section id="industries" className="py-24 sm:py-32 border-t border-white/10">
        <div className="max-w-7xl mx-auto px-5 sm:px-8">
            <SectionHead
                eyebrow="Sectors"
                title="Industries We Serve"
                sub="From single-branch firms to multi-location organisations — compliance support tailored to each sector's obligations."
            />
            <div className="mt-14 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4" data-testid="industries-grid">
                {INDUSTRIES.map((ind, i) => (
                    <Reveal key={ind} delay={(i % 4) * 0.06}>
                        <div className="group h-full border border-white/10 bg-[#101D3F]/40 p-6 hover:border-sky-400/40 hover:bg-[#101D3F] transition-colors duration-300">
                            <Building2 size={18} className="text-sky-500 group-hover:text-sky-300 transition-colors" />
                            <p className="mt-4 text-sm font-medium text-slate-200 leading-snug">{ind}</p>
                        </div>
                    </Reveal>
                ))}
            </div>
        </div>
    </section>
);

export default Industries;
